import { render, staticRenderFns } from "./TechVB.vue?vue&type=template&id=49b0b376&scoped=true"
import script from "./TechVB.vue?vue&type=script&lang=js"
export * from "./TechVB.vue?vue&type=script&lang=js"
import style0 from "./TechVB.vue?vue&type=style&index=0&id=49b0b376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b0b376",
  null
  
)

export default component.exports